
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftAvatar from "components/SoftAvatar";
import SoftBadge from "components/SoftBadge";
import team2 from "assets/images/team-2.jpg";
import Icon from "@mui/material/Icon";
import SoftSwitch from "components/SoftSwitch";
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';

export function CustomerData({data, view, onStatusChange}) {

  console.log("This is data : ",data);
const tableData = {
  columns: [
    { name: "author", align: "left" },
    { name: "function", align: "left" },
    { name: "status", align: "center" },
    { name: "comment", align: "center" },
    { name: "address", align: "center" },
    { name: "action", align: "center" },
  ],

  rows: [],
};

   data&&data.length>0&&data.map((elm,i)=>{
     tableData.rows.push( {
      author: (<SoftBox display="flex" alignItems="center" px={1} py={0.5} key={i}>
        <SoftBox mr={2}>
          <HelpOutlineOutlinedIcon fontSize="large" />
        </SoftBox>
        <SoftBox display="flex" flexDirection="column">
          <SoftTypography variant="button" fontWeight="medium">
            {elm?.name}
          </SoftTypography>
          <SoftTypography variant="caption" color="secondary">
            {elm?.phone}
          </SoftTypography>
        </SoftBox>
      </SoftBox>),
      function: (<SoftBox display="flex" flexDirection="column">
        <SoftTypography variant="caption" fontWeight="medium" color="text">
          {`phone : ${elm?.phone}`}
        </SoftTypography>
        <SoftTypography variant="caption" color="secondary">
        restaurant: {elm?.restoId?.id}
        </SoftTypography>
      </SoftBox>),
      status: (
        <SoftBadge variant="gradient" badgeContent={elm?.status || 'pending'} color={elm?.status=='resolved'?"success":"error"} size="xs" container />
      ),
      comment: (
        <SoftBox sx={{ maxWidth: '300px', minWidth: '200px' }}>
          <SoftTypography 
            variant="body2" 
            color="secondary" 
            fontWeight="medium"
            sx={{
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              lineHeight: 1.5,
              fontSize: '0.875rem',
              padding: '8px 0'
            }}
          >
            {elm?.comment || elm?.query || elm?.message || 'no comment'}
          </SoftTypography>
        </SoftBox>
      ),
      address: (
        <SoftBox sx={{ maxWidth: '250px', minWidth: '150px' }}>
          <SoftTypography 
            variant="body2" 
            color="secondary" 
            fontWeight="medium"
            sx={{
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              lineHeight: 1.4,
              fontSize: '0.825rem'
            }}
          >
            {elm?.address || 'No address provided'}
          </SoftTypography>
        </SoftBox>
      ),

      action: (
        <SoftSwitch
          checked={elm?.status === 'resolved'}
          onChange={() => onStatusChange && onStatusChange(elm._id, elm?.status === 'resolved' ? 'pending' : 'resolved')}
        />
      ),
    })
   })
  return tableData
}

export default CustomerData;
